import {GridRowParams} from '@mui/x-data-grid';
import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {Table} from '../../../../components/Table';
import {ContractDto} from '../../../../global/api';
import {CONTRACTS_TABLE_COLUMNS} from '../../constants/contracts-table-columns.constants';
import {useContractsTableData} from '../../hooks/use-contracts-table-data.hook';
import {setContractRequestCounter} from '../../stores/contract-request.store';
import {
  setContractTablePage,
  setContractTableSize,
  setContractTableSort,
  useContractsTableStore,
} from '../../stores/contracts-table.store';
import {ContractsPaper} from '../contracts-paper';
import {ContractsTableToolbar} from './contracts-table-toolbar';

export const ContractsTable: FC = () => {
  const navigate = useNavigate();
  const {page, size, sortModel} = useContractsTableStore();
  const {data, loading} = useContractsTableData();

  const handleRowClick = ({row}: GridRowParams<ContractDto>) => {
    setContractRequestCounter(row.counter);
    navigate(`/contracts/${row.id}`);
  };

  return (
    <ContractsPaper>
      <ContractsTableToolbar />
      <Table
        name="contracts-table"
        loading={loading}
        pageSize={size}
        columns={CONTRACTS_TABLE_COLUMNS}
        rows={data?.content}
        currentPage={page}
        totalPages={data?.totalPages ?? 0}
        sortModel={sortModel}
        startPageFromZero
        totalCount={data?.totalElements}
        onRowClick={handleRowClick}
        onSortModelChange={setContractTableSort}
        onPageSizeChange={setContractTableSize}
        onPaginationChange={setContractTablePage}
      />
    </ContractsPaper>
  );
};
